import { TextArea } from 'components/core';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { currentVisualizationState } from 'states';
import { UI_TEXT } from 'constants/appConstants';
import styles from './VisualizationTabs.module.css';
import { FieldTooltip } from 'molecules/fieldTooltip/FieldTooltip';

interface KpiFiltersProps {
  register: any;
  setValue: any;
  formState: any;
  isExisting?: boolean;
}

const handleKpiFiltersChange = (setValue: any) => (e: React.ChangeEvent<HTMLTextAreaElement>) => {
  setValue('kpiFilters', e.target.value, { shouldValidate: true });
};

export const Filters = ({ register, setValue, formState, isExisting = false }: KpiFiltersProps) => {
  const currentVisualization = useRecoilValue(currentVisualizationState);

  useEffect(() => {
    if (!isExisting) {
      setValue('kpiFilters', UI_TEXT.VISUALIZATION_TEMPLATES.KPI_FILTERS_CONFIG);
    }
  }, [currentVisualization]);

  const { errors } = formState;

  return (
    <div style={{ paddingBottom: '40px' }} className="col-sm-12 col-md-12 col-lg-8">
      <div className="col-sm-12 col-md-9 col-lg-9 mt-4 mb-3">
        {/* Field reference — panel body pending analyticsConfigDocs.ts KPI_FILTER_FIELD_DOCS */}
        <div className={styles.fieldRefPanel} style={{ marginBottom: 20 }}>
          <div className={styles.fieldRefHeader}>
            <span className="material-icons" style={{ fontSize: 15, color: 'var(--primary-1)' }}>
              menu_book
            </span>
            <span className={styles.fieldRefTitle}>{UI_TEXT.VISUALIZATION.KPI_FILTERS_REF_TITLE}</span>
            <span className={styles.fieldRefSub}>{UI_TEXT.VISUALIZATION.KPI_FILTERS_REF_SUB}</span>
          </div>
          <div className={styles.fieldRefGrid}>
            {/* {KPI_FILTER_FIELD_DOCS.map((doc) => ( ... ))} */}
          </div>
        </div>

        {/* KPI filters textarea */}
        <div className="mb-4">
          <div className={styles.fieldLabelRow}>
            <span className={styles.fieldLabel}>{UI_TEXT.VISUALIZATION.FIELD_KPI_FILTERS}</span>
            <FieldTooltip
              title={UI_TEXT.VISUALIZATION.KPI_FILTERS_TOOLTIP_TITLE}
              description={UI_TEXT.VISUALIZATION.KPI_FILTERS_TOOLTIP_DESC}
              example={UI_TEXT.VISUALIZATION.KPI_FILTERS_TOOLTIP_EXAMPLE}
              note={UI_TEXT.VISUALIZATION.KPI_FILTERS_TOOLTIP_NOTE}
            />
          </div>
          <div className={styles.fieldHint}>{UI_TEXT.VISUALIZATION.KPI_FILTERS_HINT}</div>

          {!isExisting && (
            <div className={styles.jsonNote}>
              <span className="material-icons" style={{ fontSize: 16, flexShrink: 0 }}>info</span>
              <strong>{UI_TEXT.VISUALIZATION.KPI_FILTERS_TEMPLATE_NOTE}</strong>
            </div>
          )}

          <TextArea
            rows={10}
            showTitle={false}
            showDescription={false}
            title=""
            {...register('kpiFilters')}
            className={`${errors.kpiFilters ? 'is-invalid' : ''}`}
            onChange={handleKpiFiltersChange(setValue)}
          />
          {errors.kpiFilters && (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {errors.kpiFilters.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};